/* @flow */

import type {Dispatch} from 'redux';
import {pushFlashMessage} from '../creator/creator-actions';

export function handleFormSubmissionError(dispatch: Dispatch<*>, jqXHRError: any) {
    const fallbackErrorMessage =
        'Something went wrong trying to submit this form. Please try again.';

    try {
        const errorObjects = JSON.parse(jqXHRError.responseText).errors.map((error) => {
            return {
                message: error.detail || fallbackErrorMessage,
            };
        });

        errorObjects.forEach((error) => {
            dispatch(
                pushFlashMessage({
                    message: error.message,
                    type: 'error',
                })
            );
        });
    } catch (e) {
        dispatch(
            pushFlashMessage({
                message: fallbackErrorMessage,
                type: 'error',
            })
        );
    }
}
